import { Link, useLocation } from "react-router-dom";
import "../../src/reports/report-nav.css";
import { storage } from "../utils/storage";
import { HiDocumentReport } from "react-icons/hi";

const MyThingsNav = () => {
  const location = useLocation();
  const url = location.pathname;
  const role = storage.getItem("role");
  const isAgentRole =
    role === "Agent" ||
    role === "Agenth" ||
    role === "Agent Collections" ||
    role.includes("Agent");

  const isMyThingsActive =
    url === "/my-things" || url === "/my-things/my-thing";
  const isTaskActive = url === "/my-things/task";
  const isQualityActive = url === "/my-things/transcriptionaudit";
  const isStrategyActive = url === "/my-things/collection-strategy";

  return (
    <div className="side-panel" style={{ width: "320px", height: "740px" }}>
      <nav className="secondary-menu marker:bg-none">
        <ul>
          {(storage.getItem("username") === "MYABCMR01" ||
            storage.getItem("username") === "MYABCQT01") && (
              <li
                className={`relative text-center cursor-pointer mb-4 hover-effect ${
                  isMyThingsActive ? "active" : ""
                }`}
              >
                <Link to="/my-things/my-thing" className="flex items-center">
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                  <a className="text-link" style={{ fontSize: "14px" }}>
                    Call Report
                  </a>
                </Link>
              </li>
            )}

          <li
            className={`relative text-center cursor-pointer mb-4 hover-effect ${
              isTaskActive ? "active" : ""
            }`}
          >
            <Link to="/my-things/task" className="flex items-center">
              <i className="fa fa-tasks" aria-hidden="true"></i>
              <a className="text-link" style={{ fontSize: "14px" }}>
                Task
              </a>
            </Link>
          </li>
          {(storage.getItem("username") === "MYABCMR01" ||
            storage.getItem("username") === "MYABCQT01") && (
              <li
                className={`relative text-center cursor-pointer mb-4 hover-effect ${
                  isQualityActive ? "active" : ""
                }`}
              >
                <Link
                  to="/my-things/transcriptionaudit"
                  className="flex items-center"
                >
                  <HiDocumentReport size="20px" />
                  <a className="text-link" style={{ fontSize: "14px" }}>
                    Transcription Audit
                  </a>
                </Link>
              </li>
            )}
          {(storage.getItem("username") === "MYABCNG01" ||
            storage.getItem("username") === "GNLNNT01") && (
            <li
              className={`relative text-center cursor-pointer mb-4 hover-effect ${
                isStrategyActive ? "active" : ""
              }`}
            >
              <Link
                to="/my-things/collection-strategy"
                className="flex items-center"
              >
                <i className="fa fa-tachometer" aria-hidden="true"></i>
                <a className="text-link" style={{ fontSize: "14px" }}>
                  Collection Strategy
                </a>
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default MyThingsNav;
